import { styled } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export const StyledFeaturesList = styled(List)(() => ({}));

export const StyledFeaturesListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
}));

export const StyledFeaturesListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: 0,
}));

export const StyledFeaturesListItemText = styled(ListItemText)(() => ({}));

export const StyledIncludedIcon = styled(CheckIcon)(() => ({
  color: '#22c55e',
}));
export const StyledExcludedIcon = styled(CloseIcon)(() => ({
  color: '#ef4444',
}));
